const HEADER_CLICK_DRAG_THRESHOLD_PX = 4;

export const SMART_TABLE_HEADER_ACTION_SELECTOR = [
  "button",
  "input",
  "select",
  "textarea",
  "a",
  "[role='button']",
  "[data-smart-table-header-action]",
  "[data-ignore-group-header-click]",
  ".ag-header-cell-resize",
  ".ag-header-cell-menu-button",
  ".ag-header-icon",
].join(",");

export interface HeaderPointerStart {
  clientX: number;
  clientY: number;
}

interface HeaderDomEvent {
  stopPropagation: () => void;
  preventDefault?: () => void;
}

export const stopHeaderInteraction = (
  event: HeaderDomEvent,
  options: { preventDefault?: boolean } = {},
): void => {
  if (options.preventDefault) {
    event.preventDefault?.();
  }
  event.stopPropagation();
};

export const isHeaderActionTarget = (target: EventTarget | null): boolean =>
  target instanceof Element && !!target.closest(SMART_TABLE_HEADER_ACTION_SELECTOR);

export const movedPastHeaderClickTolerance = (
  pointerStart: HeaderPointerStart | null,
  event: { clientX: number; clientY: number },
): boolean => {
  if (!pointerStart) {
    return false;
  }

  return (
    Math.abs(event.clientX - pointerStart.clientX) > HEADER_CLICK_DRAG_THRESHOLD_PX ||
    Math.abs(event.clientY - pointerStart.clientY) > HEADER_CLICK_DRAG_THRESHOLD_PX
  );
};
